module.exports = "/images/vendor/desiigner-svg/svg/social/Spotify.svg?f7f97af92189ec599d21f5719e47675f";